/**
 * Subsegment range
 *
 * @group ISOBMFF
 *
 * @beta
 */
export type SubsegmentRange = {
	level: number;
	rangeSize: number;
};
